/* CYME CUSTOM START: consent-ready Microsoft Clarity loader (#263) */
(() => {
  'use strict';

  const loader = document.currentScript;
  const projectId = loader?.dataset.cymeClarityProjectId;

  if (!projectId || window.__cymeClarityInitialized) {
    return;
  }

  window.__cymeClarityInitialized = true;
  window.clarity = window.clarity || function () {
    (window.clarity.q = window.clarity.q || []).push(arguments);
  };

  const signalConsent = (marketingAllowed, analyticsAllowed) => {
    window.clarity('consentv2', {
      ad_Storage: marketingAllowed ? 'granted' : 'denied',
      analytics_Storage: analyticsAllowed ? 'granted' : 'denied',
      source: 101,
    });
  };

  const signalCurrentConsent = () => {
    const customerPrivacy = window.Shopify?.customerPrivacy;

    if (
      typeof customerPrivacy?.marketingAllowed !== 'function'
      || typeof customerPrivacy?.analyticsProcessingAllowed !== 'function'
    ) {
      return false;
    }

    signalConsent(
      customerPrivacy.marketingAllowed(),
      customerPrivacy.analyticsProcessingAllowed(),
    );

    return true;
  };

  const waitForCustomerPrivacy = (attempt = 0) => {
    if (signalCurrentConsent()) {
      return;
    }

    if (attempt >= 100) {
      signalConsent(false, false);
      return;
    }

    window.setTimeout(() => waitForCustomerPrivacy(attempt + 1), 50);
  };

  const loadCustomerPrivacy = (attempt = 0) => {
    if (typeof window.Shopify?.loadFeatures === 'function') {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        (error) => {
          if (error) {
            signalConsent(false, false);
            return;
          }

          waitForCustomerPrivacy();
        },
      );

      return;
    }

    if (attempt >= 100) {
      signalConsent(false, false);
      return;
    }

    window.setTimeout(() => loadCustomerPrivacy(attempt + 1), 50);
  };

  document.addEventListener('visitorConsentCollected', (event) => {
    signalConsent(
      Boolean(event.detail?.marketingAllowed),
      Boolean(event.detail?.analyticsAllowed),
    );
  });

  if (!document.querySelector(`script[src*="clarity.ms/tag/${projectId}"]`)) {
    const clarityScript = document.createElement('script');
    clarityScript.async = true;
    clarityScript.src = `https://www.clarity.ms/tag/${projectId}?ref=shopify`;
    loader.parentNode.insertBefore(clarityScript, loader);
  }

  loadCustomerPrivacy();
})();
/* CYME CUSTOM END: consent-ready Microsoft Clarity loader (#263) */
